/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { Grid, Row, Col } from 'react-flexbox-grid';
import './style.css';
import Img from "gatsby-image";
import Link from "gatsby-link";
import * as actions from '../../actions/modal'
import * as actPortfolio from '../../actions/portfolio';
import windowSize from 'react-window-size';

//let _w = [6, 6, 4, 4, 4, 6, 6, 4, 4, 4, 4, 6, 6, 4, 4, 4,6, 6, 4, 4, 4,6, 6, 4, 4, 4];//set in props
//let _w = [4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3]

const breakpoint = {
    mobile: 727,
    ipadV: 768,
    ipadH: 1024,
    desktop:1200,
    large:1400
};


class ImgLink extends Component {
  constructor (props) {
    super(props);
    this.state = {
      screenWidth: this.props.screenWidth,
      screenHeight: this.props.screenHeight
    };
    this._openWithId =   this._openWithId.bind(this);
  };

  _openWithId(id,index) {
    //remove scroll of the body, to prevent scrolling - this is a bug of the Modal component.
    document.documentElement.style.overflowY = 'hidden';

    //send to the store, the portfolio id value
    if(this.state.screenWidth < breakpoint.mobile) {
      // if the thumbs are for different project we open at first position
      this.props.openWithId(id, 0);

    }else{
      // Gallery when the thumbs feature the same project, we open a a certain position.
      this.props.openWithId(id, index);
    }

  }



setLink(index, size, title, slug, portfolio){
  // set a link
  //set a portfolio link if the prop portfolio is set to true
  if(slug !== '' && portfolio == true){
    return (
      <a key={"i-"+index} className="cnt-item" href={"#/" + this.props.slug} onClick={() => this._openWithId(this.props.slug,this.props.index)}>
      <Img style={{'display': 'block'}} alt={title} sizes={size}/>
      {title != '' ? <p className="imgLink-p  has-text-centered">{title}</p> : ''}
      </a>
    );
  }
  //set a regular link
  if(slug !== '' && portfolio != true){
    return (
      <Link key={"i-"+index} to={this.props.slug}>
          <Img style={{'display': 'block'}} alt={title} sizes={size}/>
          {title != '' ? <p className="imgLink-p has-text-centered">{title}</p> : ''}
      </Link>

    );
  }
  //prop slug is empty, return only an image
  else{
    return(
      <div key={"i-"+index}>
      <Img style={{'display': 'block'}} alt={title} sizes={size}/>
      {title != '' ? <p className="imgLink-p has-text-centered">{title}</p> : ''}
      </div>
    )
  }

}



    render() {
        const ar1 = this.props.data.edges;


        return (
          <div>
        {ar1.map(({image}, index) => (

          this.setLink(
            index,
            //we use this src when pulled from frontmatter without using imagesharp (just a string)
            //image[0].src,
            ar1[index].node.sizes, //from imagesharp
            this.props.label,
            this.props.slug,
            this.props.portfolio
          )

      )  )}
        </div>
        );






    }
  }
  ImgLink.propTypes = {
      slug: PropTypes.string.isRequired,
      index: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      screenWidth: PropTypes.number,
      screenHeight: PropTypes.number,
      data:PropTypes.object.isRequired,
      portfolio:PropTypes.bool.isRequired

  };



  const mapStateToProps = ({ modalVisible, openWithId, close, lang, screenWidth, screenHeight }) => {
    return { modalVisible, openWithId, close, lang, screenWidth, screenHeight }
  }

  const mapDispatchToProps = dispatch => {
    return {
      openWithId: (v,i) => dispatch(actions.open_with_id(v,i)),
      close: () => dispatch(actions.close()),
     }
  }

  const ConnectedImgLink = connect(mapStateToProps, mapDispatchToProps)(ImgLink)

  export default ConnectedImgLink



// WEBPACK FOOTER //
// ./src/components/ConnectedImgLink/index.js